// extracted by mini-css-extract-plugin
export default {"paneBody":"paneBody---pqfOe","searchResults":"searchResults---O1D_8"};